export default __webpack_public_path__ + "static/media/ph.a6b04c39.svg";